import React from 'react'
import {Badge} from 'wix-ui-tpa/Badge'
import {classes} from './badge.st.css'

export const BadgeExt = props => <Badge {...props} className={classes.root} />
